/** Empty filter shapes for law-firm bonds list + team-member archives (Phase 5). */

export const EMPTY_ARCHIVE_FILTERS = {
  bondNumber: [],
  bondType: [],
  bondSubCategory: [],
  principal: [],
  professionalGuardian: [],
  estate: [],
  lawFirm: [],
  attorney: [],
  underwriting_status: [],
  startDate: null,
  endDate: null,
};

export const EMPTY_LAW_FIRM_FILTER_FIELDS = {
  bondNumber: [],
  bondType: [],
  bondSubCategory: [],
  principal: [],
  estate: [],
  attorney: [],
  status: [],
  startDate: null,
  endDate: null,
};

/** Clears filter fields except the selected law firm row(s). */
export function clearedLawFirmBondFilters(currentLawFirm) {
  return {
    ...EMPTY_LAW_FIRM_FILTER_FIELDS,
    lawFirm: currentLawFirm ?? [],
  };
}
